// src/components/GlobalModal.js
import React from 'react';
import { FiAlertTriangle, FiInfo } from 'react-icons/fi';
import { useModal } from '../context/ModalContext';
import Modal from './Modal'; 

const GlobalModal = () => {
    const { modalState, close } = useModal();
    const { isOpen, type, title, message, onConfirm, isDestructive, confirmText, cancelText } = modalState;

    // Determine Title Icon
    const TitleWithIcon = (
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
            {isDestructive || type === 'alert' ? (
                <FiAlertTriangle size={24} style={{ color: isDestructive ? 'var(--red-600)' : 'var(--orange-600)' }} />
            ) : (
                 <FiInfo size={24} style={{ color: 'var(--blue-700)' }} />
             )}
            <span>{title}</span>
        </div>
    );

    // Define Footer Buttons
    const footerButtons = (
        <>
            {type === 'confirm' && (
                <button type="button" className="btn btn-secondary" onClick={close}>
                    {cancelText || 'Cancel'} 
                </button>
            )}
            <button 
                type="button" 
                className={`btn ${isDestructive ? 'btn-danger' : 'btn-primary'}`} 
                onClick={onConfirm}
                autoFocus
            >
                {type === 'alert' ? 'OK' : (confirmText || 'Confirm')} 
            </button>
        </>
    );

    return (
        <div className="global-modal-highest-z-index-wrapper">
            {/* This local style block guarantees the global confirmation modal 
              will ALWAYS sit on top of any other modal, bypassing the 
              mobile.css !important overrides.
            */}
            <style>{`
                .global-modal-highest-z-index-wrapper .modal-overlay {
                    z-index: 9999 !important;
                }
            `}</style>

            <Modal
                isOpen={isOpen}
                onClose={close}
                title={TitleWithIcon} 
                size="slim"
                footer={footerButtons}
            >
                <p style={{ whiteSpace: 'pre-wrap', lineHeight: '1.5' }}>{message}</p>
            </Modal>
        </div>
    );
};

export default GlobalModal;